import { toHumanReadableFileSize } from '../../../utils/io/file';
import { isDefined } from '../../../utils/variables';
import { ArtifactData } from '../../state/project-artifacts-state';

export type OnCreateOptions = {
  dateTime: Date;
  tiledModelId?: string;
  gltftScanId?: string;
  orthoTileId?: string;
  pointCloudId?: string;
  comment?: string;
};

export type OnUpdateOptions = Partial<OnCreateOptions>;

export type OnDeleteOptions = {
  timelineId: string;
};

export function getArtifactDisplayName(artifact: ArtifactData) {
  const artifactName = `${artifact.name} (${toHumanReadableFileSize(artifact.size)})`;
  return isDefined(artifact.geodata) ? `${artifact.geodata.name}: ${artifactName}` : artifactName;
}
